import { IntlShape } from 'react-intl';

export type Music24DisplayCurrency = 'USD' | 'EUR';

/** Stripe carries equal USD and EUR amounts; only the symbol follows the visitor. */
export function useDisplayCurrency(): Music24DisplayCurrency {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone.startsWith('Europe/') ? 'EUR' : 'USD';
  } catch {
    return 'USD';
  }
}

export function formatPlanPrice(intl: IntlShape, cents: number, currency: Music24DisplayCurrency): string {
  return intl.formatNumber(cents / 100, {
    style: 'currency',
    currency,
    minimumFractionDigits: cents % 100 === 0 ? 0 : 2,
    maximumFractionDigits: 2,
  });
}
